<div *ngIf="message$ | async as message" class="toast-message toast-{{ message.type }}" data-test="toast-message">
  <div class="toast-message-errors">
    <p>{{ message.text }}</p>
    <ng-container *ngIf="message.errors">
      <div class="toast-message-errors" data-test="toast-messages-content">
        <div *ngFor="let error of message.errors; let i = index">
          <p data-test="toast-messages-content-item">{{ i + 1 }}. {{ error.errorNumber }} {{ getErrorMessage(error) }}</p>
        </div>
      </div>
    </ng-container>
  </div>
  <a (click)="hideElabAlert()" class="toast-close" data-test="toast-close">&#9587;</a>
</div>
